import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLanguages } from 'slices/languageSlice';
import { languageSelector } from 'slices/languageSlice';

function LanguageTabs({selectedLanguage, setSelectedLanguage}) {
    const { language } = useSelector(languageSelector);
    const dispatch = useDispatch();

    const handleTabClick = (langId) => {
        setSelectedLanguage(langId); // tab click karne pe id set karo
    };

    useEffect(() => {
        dispatch(fetchLanguages());
    }, [dispatch]);

    return (
        <div className='row-primary row_secondary flex-basis-full pt-2'>
            <h2>Select Language</h2>
            <div className="tab-wrapper">
                {language?.map((item) => (
                    <div
                        key={item?.id}
                        className={`language-tab ${selectedLanguage === item?.id ? 'active' : ''}`}
                        onClick={() => handleTabClick(item?.id)}
                    >
                        {item?.name}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default LanguageTabs;
